import { FlexBox, HintTooltip, useBreakpoint } from "@brg/ui";
import styled from "styled-components";
import { AppTester } from "../../../supporting";
import { useTranslation } from "react-i18next";
import { LayoutConst } from 'core';
import { FC, useEffect, useMemo, useState } from "react";
import { useProfile } from "@brg/auth";
import { useChannelsContext } from "shared/contexts/ChannelsContext";

const Wrapper = styled(FlexBox)`
  cursor: pointer;
  & > div > div:last-child {
      top: 35px;
  }

  @media(max-width: ${LayoutConst.screen.l}px) {
    margin-left: 16px;
  }

  @media(max-width: ${LayoutConst.screen.m}px) {
    margin: 0 0px 0 16px;
  }

  @media(max-width: ${LayoutConst.screen.md}px) {
    margin: 0 16px 0 0;
  }
`

const ChannelButton: FC = () => {
  const isTab = useBreakpoint(LayoutConst.screen.m);
  const { t } = useTranslation();
  const isGeo = AppTester.isGeograffee()
  const isSuperPuper = AppTester.isSuperPuper();
  const isGeoDafes = AppTester.isGeoDafes();
  const isHSEDesign = AppTester.isHSEDesign();
  const isCGRAVE = AppTester.isCGRAVE();
  const profile = useProfile();
  const isContinuumSite = AppTester.isContinuumSite();
  const isGameDeziiign = AppTester.isGameDeziiign();

  const { 
      channels, 
  } = useChannelsContext();

  const defaultChannelId = useMemo(() => {
    return profile?.defaultEduChannelId ?? ''
  } , [profile])

  const hasDefaultChannel = useMemo(() => {
    return !!channels?.find(({ teamId }) =>  teamId === defaultChannelId)?.teamId
  } , [channels])

  const channelId = useMemo(() => {
    if (channels?.length === 0) return ''
    if (defaultChannelId?.length > 0 && hasDefaultChannel) {
      return channels?.find(({teamId }) =>  teamId === defaultChannelId)?.teamId
    }
    return channels?.find(({ ownersIDs }) =>  
      ownersIDs?.length === 1 && ownersIDs?.includes(profile?.accountId ?? '')
    )?.teamId
  } , [channels, defaultChannelId, hasDefaultChannel])

  const baseStyle = { padding: '2px 8px 4px' };
  const geoStyle =
      (isCGRAVE || isContinuumSite) ?
        { background: "#2C2C2B", color: "#FEFEFE" } 
        : isGeo && !isGeoDafes
        ? { background: "#353A3E" }
        : isGameDeziiign
        ? { background: "#353A3E", color: "#FEFEFE" }
        : isGeoDafes || isHSEDesign
        ? { background: "#E7E7E7", color: "#70706F" }
        : {};
  const combinedStyle = { ...baseStyle, ...geoStyle };

  if (isTab || channelId === '') {
    return null;
  }

  return (
    <Wrapper onClick={() => window.open(process.env.REACT_APP_URL_MEDIIIA_COM + '/teams/' + channelId, '_SELF')}>
      <HintTooltip 
    // @ts-ignore
    customStyle={combinedStyle} noArrow positionY="bottom" z={10000} onWhiteBg={!isGeo && !isSuperPuper}
                   text={t("hints.channel")}>
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M4.78613 13.6582H11.2861C12.7666 13.6584 13.9717 14.8633 13.9717 16.3438V26.2139C13.9717 27.6944 12.7666 28.9002 11.2861 28.9004H4.78613C3.3055 28.9004 2.09961 27.6945 2.09961 26.2139V16.3438C2.09961 14.8631 3.3055 13.6582 4.78613 13.6582ZM18.7139 20.0576H25.2139C26.6945 20.0576 27.9003 21.2626 27.9004 22.7432V26.2139C27.9004 27.6945 26.6945 28.9004 25.2139 28.9004H18.7139C17.2334 28.9002 16.0283 27.6944 16.0283 26.2139V22.7432C16.0284 21.2627 17.2335 20.0578 18.7139 20.0576ZM4.78613 15.3154C4.21827 15.3154 3.75684 15.7769 3.75684 16.3438V26.2139C3.75684 26.7807 4.21827 27.2432 4.78613 27.2432H11.2861C11.8538 27.2429 12.3145 26.7805 12.3145 26.2139V16.3438C12.3145 15.7771 11.8538 15.3157 11.2861 15.3154H4.78613ZM18.7139 21.7148C18.1462 21.7151 17.6856 22.1766 17.6855 22.7432V26.2139C17.6855 26.7805 18.1462 27.2429 18.7139 27.2432H25.2139C25.7817 27.2432 26.2432 26.7807 26.2432 26.2139V22.7432C26.2431 22.1764 25.7817 21.7148 25.2139 21.7148H18.7139ZM18.7139 3.09961H25.2139C26.6945 3.09961 27.9004 4.3055 27.9004 5.78613V15.6562C27.9004 17.1369 26.6945 18.3418 25.2139 18.3418H18.7139C17.2334 18.3416 16.0283 17.1367 16.0283 15.6562V5.78613C16.0283 4.30564 17.2334 3.09984 18.7139 3.09961ZM18.7139 4.75684C18.1462 4.75706 17.6855 5.21947 17.6855 5.78613V15.6562C17.6855 16.2229 18.1462 16.6843 18.7139 16.6846H25.2139C25.7817 16.6846 26.2432 16.2231 26.2432 15.6562V5.78613C26.2432 5.21933 25.7817 4.75684 25.2139 4.75684H18.7139ZM4.78613 3.09961H11.2861C12.7666 3.09984 13.9717 4.30564 13.9717 5.78613V9.25684C13.9716 10.7373 12.7665 11.9422 11.2861 11.9424H4.78613C3.30554 11.9424 2.09968 10.7374 2.09961 9.25684V5.78613C2.09961 4.3055 3.3055 3.09961 4.78613 3.09961ZM4.78613 4.75684C4.21827 4.75684 3.75684 5.21933 3.75684 5.78613V9.25684C3.7569 9.82359 4.21831 10.2852 4.78613 10.2852H11.2861C11.8538 10.2849 12.3144 9.82345 12.3145 9.25684V5.78613C12.3145 5.21947 11.8538 4.75706 11.2861 4.75684H4.78613Z" fill="#909090" stroke="white" stroke-width="0.2"/>
        </svg>
      </HintTooltip>
    </Wrapper>
  )
}

export default ChannelButton;import { FlexBox, HintTooltip, useBreakpoint } from "@brg/ui";
import styled from "styled-components";
import { AppTester } from "../../../supporting";
import { useTranslation } from "react-i18next";
import { LayoutConst } from 'core';
import { FC, useEffect, useMemo, useState } from "react";
import { useProfile } from "@brg/auth";
import { useChannelsContext } from "shared/contexts/ChannelsContext";

const Wrapper = styled(FlexBox)`
  cursor: pointer;
  & > div > div:last-child {
      top: 35px;
  }

  @media(max-width: ${LayoutConst.screen.l}px) {
    margin-left: 16px;
  }

  @media(max-width: ${LayoutConst.screen.m}px) {
    margin: 0 0px 0 16px;
  }

  @media(max-width: ${LayoutConst.screen.md}px) {
    margin: 0 16px 0 0;
  }
`

const ChannelButton: FC = () => {
  const isTab = useBreakpoint(LayoutConst.screen.m);
  const { t } = useTranslation();
  const isGeo = AppTester.isGeograffee()
  const isSuperPuper = AppTester.isSuperPuper();
  const isGeoDafes = AppTester.isGeoDafes();
  const isHSEDesign = AppTester.isHSEDesign();
  const isCGRAVE = AppTester.isCGRAVE();
  const profile = useProfile();
  const isContinuumSite = AppTester.isContinuumSite();
  const isGameDeziiign = AppTester.isGameDeziiign();

  const { 
      channels, 
  } = useChannelsContext();

  const defaultChannelId = useMemo(() => {
    return profile?.defaultEduChannelId ?? ''
  } , [profile])

  const hasDefaultChannel = useMemo(() => {
    return !!channels?.find(({ teamId }) =>  teamId === defaultChannelId)?.teamId
  } , [channels])

  const channelId = useMemo(() => {
    if (channels?.length === 0) return ''
    if (defaultChannelId?.length > 0 && hasDefaultChannel) {
      return channels?.find(({teamId }) =>  teamId === defaultChannelId)?.teamId
    }
    return channels?.find(({ ownersIDs }) =>  
      ownersIDs?.length === 1 && ownersIDs?.includes(profile?.accountId ?? '')
    )?.teamId
  } , [channels, defaultChannelId, hasDefaultChannel])

  const baseStyle = { padding: '2px 8px 4px' };
  const geoStyle =
      (isCGRAVE || isContinuumSite) ?
        { background: "#2C2C2B", color: "#FEFEFE" } 
        : isGeo && !isGeoDafes
        ? { background: "#353A3E" }
        : isGameDeziiign
        ? { background: "#353A3E", color: "#FEFEFE" }
        : isGeoDafes || isHSEDesign
        ? { background: "#E7E7E7", color: "#70706F" }
        : {};
  const combinedStyle = { ...baseStyle, ...geoStyle };

  if (isTab || channelId === '') {
    return null;
  }

  return (
    <Wrapper onClick={() => window.open(process.env.REACT_APP_URL_MEDIIIA_COM + '/teams/' + channelId, '_SELF')}>
      <HintTooltip 
    // @ts-ignore
    customStyle={combinedStyle} noArrow positionY="bottom" z={10000} onWhiteBg={!isGeo && !isSuperPuper}
                   text={t("hints.channel")}>
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M4.78613 13.6582H11.2861C12.7666 13.6584 13.9717 14.8633 13.9717 16.3438V26.2139C13.9717 27.6944 12.7666 28.9002 11.2861 28.9004H4.78613C3.3055 28.9004 2.09961 27.6945 2.09961 26.2139V16.3438C2.09961 14.8631 3.3055 13.6582 4.78613 13.6582ZM18.7139 20.0576H25.2139C26.6945 20.0576 27.9003 21.2626 27.9004 22.7432V26.2139C27.9004 27.6945 26.6945 28.9004 25.2139 28.9004H18.7139C17.2334 28.9002 16.0283 27.6944 16.0283 26.2139V22.7432C16.0284 21.2627 17.2335 20.0578 18.7139 20.0576ZM4.78613 15.3154C4.21827 15.3154 3.75684 15.7769 3.75684 16.3438V26.2139C3.75684 26.7807 4.21827 27.2432 4.78613 27.2432H11.2861C11.8538 27.2429 12.3145 26.7805 12.3145 26.2139V16.3438C12.3145 15.7771 11.8538 15.3157 11.2861 15.3154H4.78613ZM18.7139 21.7148C18.1462 21.7151 17.6856 22.1766 17.6855 22.7432V26.2139C17.6855 26.7805 18.1462 27.2429 18.7139 27.2432H25.2139C25.7817 27.2432 26.2432 26.7807 26.2432 26.2139V22.7432C26.2431 22.1764 25.7817 21.7148 25.2139 21.7148H18.7139ZM18.7139 3.09961H25.2139C26.6945 3.09961 27.9004 4.3055 27.9004 5.78613V15.6562C27.9004 17.1369 26.6945 18.3418 25.2139 18.3418H18.7139C17.2334 18.3416 16.0283 17.1367 16.0283 15.6562V5.78613C16.0283 4.30564 17.2334 3.09984 18.7139 3.09961ZM18.7139 4.75684C18.1462 4.75706 17.6855 5.21947 17.6855 5.78613V15.6562C17.6855 16.2229 18.1462 16.6843 18.7139 16.6846H25.2139C25.7817 16.6846 26.2432 16.2231 26.2432 15.6562V5.78613C26.2432 5.21933 25.7817 4.75684 25.2139 4.75684H18.7139ZM4.78613 3.09961H11.2861C12.7666 3.09984 13.9717 4.30564 13.9717 5.78613V9.25684C13.9716 10.7373 12.7665 11.9422 11.2861 11.9424H4.78613C3.30554 11.9424 2.09968 10.7374 2.09961 9.25684V5.78613C2.09961 4.3055 3.3055 3.09961 4.78613 3.09961ZM4.78613 4.75684C4.21827 4.75684 3.75684 5.21933 3.75684 5.78613V9.25684C3.7569 9.82359 4.21831 10.2852 4.78613 10.2852H11.2861C11.8538 10.2849 12.3144 9.82345 12.3145 9.25684V5.78613C12.3145 5.21947 11.8538 4.75706 11.2861 4.75684H4.78613Z" fill="#909090" stroke="white" stroke-width="0.2"/>
        </svg>
      </HintTooltip>
    </Wrapper>
  )
}

export default ChannelButton;